import { customerSelectorStyles as AddressBookPopUp } from "@insite/content-library/Components/CustomerSelector";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { productAddToCartButtonStyles } from "@tCooneyBrothers/Overrides/Components/ProductAddToCartButton";
import { css } from "styled-components";
// D:\InsiteCooneyBrothers\cooneybrothers\src\FrontEnd\modules\content-library\src\Components\CustomerSelector.tsx
productCardStyles.rightColumnGridContainer = {
    css: css`
        background-color: #fafafa;
        padding: 15px;
    `,
};

productCardStyles.actionsGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        padding-left: 0;
    `,
};

productAddToCartButtonStyles.typographyProps = {
    css: css`
        font-size: 13px;
        font-weight: normal;
    `,
};

productDescriptionStyles.productDetailLink!.typographyProps!.css = css`
    color: #353432 !important;
    font-size: 14px;
    font-weight: bold;

    &:hover {
        opacity: 0.8;
    }
`;
productGridCardStyles.wrapper!.css = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-bottom: 0px;
`;
paginationStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 40% !important;
                        `,
                        css`
                            width: 30%;
                        `,
                    ],
                    "max",
                )}
            > div {
                padding: 0;
                width: auto;
                display: flex;
                align-items: center;
                label {
                    width: auto;
                    font-size: 12px;
                    line-height: 23px;
                    text-transform: uppercase;
                    padding-top: 0;
                    & + div {
                        width: auto;
                    }
                }
            }
        `,
        linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 60% !important;
                            display: contents;
                        `,
                        css`
                            width: 70%;
                        `,
                    ],
                    "max",
                )}

            ul {
                li {
                    &:first-child,
                    &:last-child,
                    &:nth-child(2),
                    &:nth-last-child(2) {
                        button {
                            max-width: 20px;
                        }
                    }

                    button {
                        width: auto;
                        padding: 4px 7px 3px;
                        span {
                            font-size: 12px;
                        }
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            min-height: 20px;
            padding: 0px;
            border-radius: 50%;
        `,
    },
};

AddressBookPopUp.pagination = {
    cssOverrides: {
        perPageSelect: css`
            align-items: center;
            justify-content: flex-end !important;
            // width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        // width: 60%;
                    `,
                    css`
                        // width: 40%;
                    `,
                    css`
                        // width: 50%;
                    `,
                ])}
            > div {
                padding: 0;
                // width: auto;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                label {
                    width: auto;
                    font-size: 12px;
                    line-height: 23px;
                    text-transform: uppercase;
                    padding-top: 0;
                    & + div {
                        // width: auto;
                    }
                }
                select {
                    border-radius: 25px !important;
                    height: 30px;
                }
                span[class^="IconWrapper"] {
                    top: -2px;
                    padding: 6px;
                }
            }
        `,
        linkList: css`
            justify-content: flex-end !important;
            ul {
                li {
                    &:first-child,
                    &:last-child,
                    &:nth-child(2),
                    &:nth-last-child(2) {
                        button {
                            max-width: 24px;
                        }
                    }

                    button {
                        width: auto;
                        padding: 4px 7px 3px;
                        span {
                            font-size: 12px;
                        }
                    }
                }
            }
        `,
        currentButton: css`
            width: 20px;
            min-height: 20px;
            padding: 0px;
            border-radius: 50%;
        `,
    },
};

searchWithinStyles.searchTextField = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            width: 100%;
            input {
                overflow-wrap: break-word;
                word-break: break-all;
                padding: 12px 30px 12px 10px !important;
            }
        `,
    },
};
